import React from "react";

import { ButtonBase, CircularProgress, Typography } from "@mui/material";

const Button = ({ children, size, bgcolor, isLoading, styles, type, textStyles, disabled, loadingStyles, px, py, whiteTxt, ...props }) => {
  const sizesStyles = {
    width: size === "block" ? "100%" : "auto",
    maxWidth: size === "large" ? "350px" : size === "block" ? "100%" : "200px",
    px: px ? px : size === "small" ? 3 : size === "large" ? { xs: 4, lg: 7 } : 4,
    py: py ? py : size === "small" ? 1.5 : size === "large" ? 1.5 : size === "block" ? 1.5 : 2,
    borderRadius: "35px",
  };
  const colorStyles =
    bgcolor === "gradient"
      ? {
        background: "linear-gradient(to right, #1B9CCA, #9048FB)",
      }
      : bgcolor === "main"
        ? {
          background: "linear-gradient(to right, #5B2C9F, #1B9CCA)",
        }
        : bgcolor === "gradientLight"
          ? {
            background: "linear-gradient(to right, #5BAEC8, #6E5792)",
          }
          : {
            bgcolor: bgcolor || "white",
            border: bgcolor === "outline" ? "1px solid #364CD6" : "1px solid transparent",
          };

  return (
    <ButtonBase
      disabled={!!isLoading || disabled}
      sx={{
        opacity: isLoading || disabled ? 0.8 : 1,
        ...sizesStyles,
        ...colorStyles,
        ...styles,
      }}
      type={type}
      {...props}
    >
      <Typography
        noWrap
        sx={{
          fontWeight: bgcolor ? 500 : 600,
          fontSize: size === "large" ? "16px" : "14px",
          color: whiteTxt ? "#fff" : bgcolor?.includes("gradient") ? "white" : bgcolor === "outline" ? "#364CD6" : "black",
          ...textStyles,
        }}
      >
        {isLoading ? <CircularProgress size={16} sx={{ color: '#f1f1f1', ...loadingStyles }} /> : children}
      </Typography>
    </ButtonBase>
  );
};

Button.defaultProps = {
  bgcolor: "gradient",
  type: 'button',
};

export default Button;
